import {useState} from 'react';
import {genValorNombreEvento} from '../../common/defaults';
import {
   ObjectOf,
   UseBooleanEventHandler,
   UseBooleanResult,
   UseBooleanStateHandler
} from './useBooleanTypes';

const useBoolean = <T extends boolean | ObjectOf<boolean>>(
   valorInicial: T,
   {generarValorNombre} = {generarValorNombre: genValorNombreEvento}
): UseBooleanResult<T> => {
   const [estado, setEstado] = useState<T>(valorInicial);

   const genValorNombre = (event) => {
      return generarValorNombre(event);
   };

   function processNewStateValue(newBoolValue: boolean, prevState: T, nombre?: string): T {
      if (typeof prevState === 'boolean' || !nombre) {
         return newBoolValue as T;
      } else {
         return {...(prevState as ObjectOf<boolean>), [nombre]: newBoolValue} as T;
      }
   }

   const toggle: UseBooleanStateHandler = (nombre) => {
      setEstado((prev) => {
         if (typeof prev === 'boolean' || !nombre) {
            return !prev as T;
         } else {
            return {...(prev as ObjectOf<boolean>), [nombre]: !prev[nombre]} as T;
         }
      });
   };

   const setTrue: UseBooleanStateHandler = (nombre) => {
      setEstado((prev) => {
         return processNewStateValue(true, prev, nombre);
      });
   };

   const setFalse: UseBooleanStateHandler = (nombre) => {
      setEstado((prev) => {
         return processNewStateValue(false, prev, nombre);
      });
   };

   const handleBoolChange: UseBooleanEventHandler = (event) => {
      const nombreValor = genValorNombre(event);
      setEstado((prev) => {
         return processNewStateValue(nombreValor.value, prev, nombreValor.name);
      });
   };

   return [estado, {toggle, setFalse, setTrue, setBoolean: setEstado, handleBoolChange}];
};

export default useBoolean;
